import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, share } from 'rxjs/operators';

import { AuthService } from '../shared/services/auth.service';
import { StripeCoupon } from './models/models';
import { Product } from './models/product';


const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
}

@Injectable()
export class ProductService {

  /** selected program access type of the course from the pricing page, course list or course demo */
  selectedProgramAccessType: number;
  private _products$: Array<Product>;
  private _anoymousProducts$: Array<Product>;
  private _studioProducts$: Array<Product>;

  get selectedProduct(): Product {
    return this._studioProducts$.find(x => x.programAccessTypeId == this.selectedProgramAccessType);
  }

  constructor(private _http: HttpClient
    , private _authService: AuthService) {
  }

  loadProducts(skipCache?: boolean): Observable<Array<Product>> {
    // if (this._authService.isAuthenticated()) {
    //   return this.fetchProducts(skipCache);
    // }
    // else {
    //   return this.fetchAnonymousProducts(skipCache);
    // }
    return this.fetchStudioProducts(skipCache);
  }

  getProduct(programAccessTypeId: number): Product {
    if (this._studioProducts$ != null && this._studioProducts$.length > 0) {
      return this._studioProducts$.find(t => t.programAccessTypeId === programAccessTypeId);
    }
    else if (this._authService.isAuthenticated()) {
      return this._products$.find(t => t.programAccessTypeId === programAccessTypeId);
    }
    else {
      return this._anoymousProducts$.find(t => t.programAccessTypeId == programAccessTypeId);
    }
  }

  // private fetchProducts(skipCache?: boolean): Observable<Array<Product>> {
  //   let obs = this._http.get<Array<Product>>(`api/stripe/products`).pipe(
  //     map(t => t.map(s => new Product(s))),
  //     share()
  //   );

  //   if (this._products$ != null && !skipCache) {
  //     return of(this._products$);
  //   }
  //   else {
  //     obs.subscribe(data => {
  //       this._products$ = data;
  //     });
  //     return obs;
  //   }
  // }

  // private fetchAnonymousProducts(skipCache?: boolean): Observable<Array<Product>> {
  //   let obs = this._http.get<Array<Product>>(`api/stripe/anonymousProducts`).pipe(
  //     map(t => t.map(s => new Product(s))),
  //     share()
  //   );

  //   if (this._anoymousProducts$ != null && !skipCache) {
  //     return of(this._anoymousProducts$);
  //   }
  //   else {
  //     obs.subscribe(data => {
  //       this._anoymousProducts$ = data;
  //     });
  //     return obs;
  //   }
  // }

  private fetchStudioProducts(skipCache?: boolean): Observable<Array<Product>> {
    let obs = this._http.get<Array<Product>>(`api/stripe/studioAcademyProducts`).pipe(
      map(t => t.map(s => new Product(s))),
      share()
    );

    if (this._studioProducts$ != null && !skipCache) {
      return of(this._studioProducts$);
    }
    else {
      obs.subscribe(data => {
        this._studioProducts$ = data;
      });
      return obs;
    }
  }

  /**
     * Check coupon for validity
     * @param email
     */
  isCouponValid(coupon: string): Observable<any> {
    return this._http.post('api/stripe/coupon-valid', JSON.stringify(coupon), httpOptions);
  }

  /**
   * Gets stripe coupon from the server
   */
  getStripeCoupon(couponId: string): Observable<StripeCoupon> {
    return this._http.get('api/stripe/coupon/' + couponId).pipe(map(response => new StripeCoupon(response)));
  }

  /**
   * Returns a coupon description
   * @param coupon
   */
  buildCouponMessage(coupon: StripeCoupon): string {
    const duration = coupon.Duration;
    const months = coupon.DurationInMonths;
    const percent = coupon.PercentOff;
    const amountOff = coupon.AmountOff;
    const maxRedemptions = coupon.MaxRedemptions; // Maximum number of times this coupon can be redeemed, in total, before it is no longer valid.

    let message = "";
    if (percent != null) {
      message += percent + '% Off ';
    }
    else if (amountOff != null) {
      message += '$' + amountOff + ' Off ';
    }

    if (maxRedemptions < 1) {
      if (duration === 'forever') {
        message += 'this invoice and all future invoices.';
      }
      else if (duration === 'once') {
        message += "today's charge.";
      }
      else if (duration === 'repeating' && months > 0) {
        message += 'this invoice and the following invoices for ' + months + ' months.'
      }
    }

    return message;
  }
}
